module.exports = __webpack_public_path__ + "media/images/battery-00-28dec48a5a7bb1e83dae04ff07ba47ed.png";